import type { GalleryItem } from "@/types";
import { galleryCategoryLabels } from "@/lib/galleryMeta";

interface GalleryGridProps {
  items: GalleryItem[];
  onOpen: (index: number) => void;
}

export default function GalleryGrid({ items, onOpen }: GalleryGridProps) {
  return (
    <div className="columns-1 gap-4 sm:columns-2 lg:columns-3 [&>*]:mb-4">
      {items.map((item, index) => (
        <button
          key={item.id}
          type="button"
          onClick={() => onOpen(index)}
          aria-label={`Ampliar imagen: ${item.titulo}`}
          className="group relative block w-full overflow-hidden rounded-lg bg-background-200 text-left animate-fade-up cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 focus-visible:ring-offset-2 focus-visible:ring-offset-background-50"
          style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
        >
          <img
            src={item.imagen_url}
            alt={`${item.titulo} — trabajo realizado por AXONIA GROUP`}
            title={`${item.titulo} — ${galleryCategoryLabels[item.categoria]}`}
            className="h-auto w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-primary-950/85 via-primary-950/15 to-transparent opacity-90"></div>
          <div className="absolute inset-x-0 bottom-0 p-4">
            <span className="text-[11px] font-label font-semibold uppercase tracking-wider text-accent-300">
              {galleryCategoryLabels[item.categoria]}
            </span>
            <p className="mt-1 text-sm font-heading font-semibold text-primary-50 md:text-base">
              {item.titulo}
            </p>
          </div>
          <span className="absolute right-4 top-4 flex h-9 w-9 items-center justify-center rounded-full bg-primary-50/15 text-primary-50 opacity-0 backdrop-blur-sm transition-opacity duration-300 group-hover:opacity-100">
            <i className="ri-zoom-in-line text-lg leading-none" aria-hidden="true"></i>
          </span>
        </button>
      ))}
    </div>
  );
}